import { z } from 'zod';

import { GuaranteedValueSchema } from './guaranteed-value';

export const LDPointSchema = z.tuple([z.date(), z.number()]);

export type LDPoint = z.infer<typeof LDPointSchema>;

export const LDSeriesSchema = z.object({
  points: z.array(LDPointSchema),
});

export type LDSeries = z.infer<typeof LDSeriesSchema>;

export const ValuePointSchema = z.tuple([z.date(), z.number()]);

export type ValuePoint = z.infer<typeof ValuePointSchema>;

export const ValueSeriesSchema = z.object({
  points: z.array(ValuePointSchema),
});

export type ValueSeries = z.infer<typeof ValueSeriesSchema>;

export const MetricUnitSchema = z.enum(['percent', 'MWh']);

export type MetricUnit = z.infer<typeof MetricUnitSchema>;

export const MetricSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  order: z.number(),
  unit: MetricUnitSchema.default('percent'),

  value: z.number(),
  guaranteedValue: GuaranteedValueSchema.optional(),
  capedLD: z.number().optional(),

  valueSeries: ValueSeriesSchema.optional(),
  capedLDSeries: LDSeriesSchema.optional(),
});

export type Metric = z.infer<typeof MetricSchema>;

export const MetricsGroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  order: z.number(),
  metrics: z.array(MetricSchema),
  capedLD: z.number().optional(),
});

export type MetricsGroup = z.infer<typeof MetricsGroupSchema>;

export const TimeBasedMetricsSchema = z.object({
  start: z.date(),
  end: z.date(),
  currency: z.string(), // ISO 4217 currency codes
  groups: z.array(MetricsGroupSchema),
  isDataAvailable: z.boolean().default(true),
});

export type TimeBasedMetrics = z.infer<typeof TimeBasedMetricsSchema>;
